module.exports = __webpack_public_path__ + "img/10.6cbe7ca8.png";